import { CarouselButton } from '@carvana/ds-button';
import { CarouselButtonProps } from '@carvana/ds-button';
import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';

export const GalleryContainer = createComponent('div', {
  className:
    'group relative mx-2xl mt-xl flex max-w-full flex-col gap-xl md:mx-0'
});

export const GalleryScrollContainer = createComponent<
  ElementWithProps<{ isDragging: boolean }>
>('div', ({ isDragging }) => ({
  className: cx(
    'no-scrollbar relative flex gap-xl overflow-x-scroll scroll-auto rounded-md',
    {
      'snap-x snap-mandatory': !isDragging
    }
  )
}));

export const NavButton = createComponent<
  ElementWithProps<CarouselButtonProps & { isVisible: boolean }>
>(CarouselButton, ({ direction, isVisible }) => ({
  size: 'sm',
  direction,
  className: cx(
    'absolute top-[calc(50%-16px)] z-10 opacity-0 transition-opacity duration-300',
    direction === 'left' ? 'left-xl' : 'right-xl',
    isVisible ? 'group-hover:opacity-100' : 'pointer-events-none'
  )
}));

export const PhotosAnnotation = createComponent('div', {
  className: cx(
    'absolute bottom-0 right-0',
    'flex items-center gap-md',
    'rounded-br-md rounded-tl-md',
    'border border-border-inverse-transparent',
    // Note: Using arbitrary values because DS doesn't have background-muted-strong with 20%/40% opacity
    'bg-[#151d2933] backdrop-blur-[5px] transition-all duration-200 group-hover:bg-[#151d2966]',
    'px-xl py-[5px]',
    'text-text-inverse t-label-sm',
    'pointer-events-none'
  )
});
